export enum VoipCallTypeEnum {
  INTERNAL_NO = "INTERNAL_NO",
  PHONE = "PHONE",
}

export const VoipCallTypeEnumValues = [
  VoipCallTypeEnum.INTERNAL_NO,
  VoipCallTypeEnum.PHONE
]
